import React from 'react';

interface Props {
  fill: string;
  width?: string;
}

const Logo: React.FC<Props> = ({ fill, width = '1.70667in' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} viewBox="0 0 512 512">
      <path
        id="C"
        fill={fill}
        stroke={fill}
        strokeWidth="1"
        d="M 340.75,312.25
             C 340.75,312.25 412.50,335.00 412.50,335.00
               401.50,375.00 383.21,404.71 357.62,424.12
               332.04,443.54 299.58,453.25 260.25,453.25
               211.58,453.25 171.58,436.62 140.25,403.38
               108.91,370.12 93.25,324.67 93.25,267.00
               93.25,206.00 109.00,158.62 140.50,124.88
               172.00,91.12 213.41,74.25 264.75,74.25
               309.58,74.25 346.00,87.50 374.00,114.00
               390.66,129.67 403.16,152.17 411.50,181.50
               411.50,181.50 338.25,199.00 338.25,199.00
               333.91,180.00 324.88,165.00 311.12,154.00
               297.38,143.00 280.66,137.50 261.00,137.50
               233.83,137.50 211.79,147.25 194.88,166.75
               177.96,186.25 169.50,217.84 169.50,261.50
               169.50,307.84 177.83,340.84 194.50,360.50
               211.16,380.17 232.83,390.00 259.50,390.00
               279.16,390.00 296.08,383.75 310.25,371.25
               324.41,358.75 334.58,339.09 340.75,312.25 Z"
      />
    </svg>
  );
};

export default Logo;
